import React from "react";
import Navbar from "../Components/Navbar";
import SwiperBanner from "../Components/home/SwiperBanner";
import StatsBar from "../Components/home/StatsBar";
import WorkflowSection from "../Components/home/WorkflowSection";
import OurServicesGrid from "../Components/home/OurServicesGrid";
import WhyPricingTestimonial from "../Components/home/WhyPricingTestimonial";
import Footer from "../Components/Footer";
import Faqs from "../Components/home/Faqs";
import TrustBadgesBar from "../Components/home/TrustBadgesBar";

const Home = () => {
  return (
    <>
      <Navbar />
      <SwiperBanner />
      <StatsBar />
      <WorkflowSection />
      <OurServicesGrid />
      <WhyPricingTestimonial />
      <Faqs />
      <TrustBadgesBar />
      <Footer />
    </>
  );
};
export default Home;
